// extracted by mini-css-extract-plugin
export default {"button":"_hN1az4NdHTeKs8prMVo"};